import { ActionIcon, Group, Text } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { useEffect, useRef } from "react";
import AssistantReviewWidgets from "../AssistantReviewWidgets";
import { getAssistantReviewStatusKeys } from "../assistantReviewMessage";
import css from "./DockReviewCard.module.scss";

const TEXT_STRONG = "#253047";
const TEXT_MUTED = "#667085";

// Drafts to confirm, stacked straight on top of the bar. Deliberately not a
// modal and not a veil: the page behind stays bright and clickable, so the
// card has to carry its own separation through shadow and border alone.
//
// Widgets render oldest first, so the newest is the last one in the card. When
// several arrive the card opens scrolled to it — the one the assistant just
// talked about is the one you should be looking at, not the one above it.
const DockReviewCard = ({ message, style, onCollapse }) => {
  const bodyRef = useRef(null);
  const widgetCount = getAssistantReviewStatusKeys(message).length;

  useEffect(() => {
    const body = bodyRef.current;
    if (!body) return;
    body.scrollTop = body.scrollHeight;
  }, [message?.id, widgetCount]);

  return (
    <section className={css.card} style={style} aria-label="Review draft">
      <Group position="apart" spacing="sm" className={css.header}>
        <div>
          <Text weight={800} size="sm" color={TEXT_STRONG}>
            Review draft
          </Text>
          <Text size="xs" color={TEXT_MUTED}>
            Edit and confirm — the page stays live.
          </Text>
        </div>
        <ActionIcon
          aria-label="Collapse review draft"
          variant="subtle"
          color="dark"
          onClick={onCollapse}
        >
          <IconX size={17} />
        </ActionIcon>
      </Group>
      <div className={css.body} ref={bodyRef}>
        <AssistantReviewWidgets message={message} renderContext="voice" />
      </div>
    </section>
  );
};

export default DockReviewCard;
